import { Paper, styled } from '@mui/material';
import { shouldNotForwardProps } from '@/shared/helpers';
export const MainContentStyled = styled(Paper, 
// 'paddingX', 'tight', 'loose' properties should be excluded from DOM here despite they are not used in this
// particular css, since they still passed throw.
shouldNotForwardProps('backdrop', 'headOnly', 'paddingX', 'tight', 'loose', 'maxWidth'))(({ theme, backdrop, headOnly, maxWidth }) => ({
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    boxShadow: theme.shadows[10],
    padding: 0,
    ...(backdrop && {
        position: 'relative',
    }),
    // TODO: check if `headOnly` prop used correctly in all places after refactoring MainContentPaper component.
    ...(headOnly && {
        marginBottom: theme.spacing(4),
        marginTop: theme.spacing(2),
        flex: 'unset',
    }),
    ...(maxWidth && {
        maxWidth,
    }),
}));
